import { maskitoTransform } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

export function formatNumber(value: string, isAbsoluteNumber: boolean) {
  // Mache aus 1234.55 -> 1234,55
  const numberWithCommaSeparator = maskitoTransform(
    value,
    maskitoNumberOptionsGenerator({
      thousandSeparator: '',
      decimalSeparator: ',',
      maximumFractionDigits: !isAbsoluteNumber ? 2 : 0,
    }),
  );

  // Mache aus 1234,55 -> 1.234,55
  const numberWithThousandSeparator = maskitoTransform(
    numberWithCommaSeparator,
    maskitoNumberOptionsGenerator({
      thousandSeparator: '.',
      decimalSeparator: ',',
      maximumFractionDigits: !isAbsoluteNumber ? 2 : 0,
      minimumFractionDigits: !isAbsoluteNumber ? 2 : 0,
    }),
  );

  return numberWithThousandSeparator;
}
